import React from "react";
import LocalizationContext from "../utils/LocalizationContext";

import NavBar from "../components/NavBar";
import PageContentLoading from "../components/PageContentLoading";
import Washer from "../pages/Washer";
import useMenu from "../utils/Hooks/useMenu";
import useLocale from "../utils/Hooks/useLocale";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.ABM,
    key: "Washer",
  };
  const screenName = 300
  const locale = useLocale(screenName);

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{ locale: locale }}>
        <NavBar
          screenName={screenName}
          moduleName={90}
          MenuOptions={menu}
          currentPage={currentPage}
        >
          {locale ? <Washer /> : <PageContentLoading />}
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};

